import { Grid } from '@chakra-ui/react';
import React from 'react';

import useApiQuery from 'lib/api/useApiQuery';
import { useI18n } from 'lib/i18n/context';
import { STATS_COUNTER } from 'stubs/stats';
import StatsWidget from 'ui/shared/stats/StatsWidget';

import DataFetchAlert from '../shared/DataFetchAlert';
import { getStatsCounterDescription, getStatsCounterTitle } from './i18n';

const UNITS_WITHOUT_SPACE = [ 's' ];

// 将 ETH 替换为 BOT
const replaceEthWithBot = (str: string | undefined): string | undefined => {
  if (!str) return str;
  return str.replace(/ETH/g, 'BOT').replace(/Eth/g, 'Bot').replace(/eth/g, 'bot');
};

const NumberWidgetsList = () => {
  const { t } = useI18n();
  const { data, isPlaceholderData, isError } = useApiQuery('stats_counters', {
    queryOptions: {
      placeholderData: { counters: Array(10).fill(STATS_COUNTER) },
    },
  });

  if (isError) {
    return <DataFetchAlert/>;
  }

  return (
    <Grid
      gridTemplateColumns={{ base: 'repeat(1, 1fr)', lg: 'repeat(4, 1fr)' }}
      gridGap="8px"
    >
      {
        data?.counters?.map(({ id, title, value, units, description }, index) => {
          // 替换 ETH 为 BOT
          const displayTitle = replaceEthWithBot(getStatsCounterTitle(id, title, t)) || '';
          const displayUnits = replaceEthWithBot(units);
          const displayDescription = replaceEthWithBot(getStatsCounterDescription(id, description, t));

          let unitsStr = '';
          if (displayUnits && UNITS_WITHOUT_SPACE.includes(displayUnits)) {
            unitsStr = displayUnits;
          } else if (displayUnits) {
            unitsStr = ' ' + displayUnits;
          }

          return (
            <StatsWidget
              key={ id + (isPlaceholderData ? index : '') }
              label={ displayTitle }
              value={ `${ Number(value).toLocaleString(undefined, { maximumFractionDigits: 3, notation: 'compact' }) }${ unitsStr }` }
              isLoading={ isPlaceholderData }
              hint={ displayDescription }
            />
          );
        })
      }
    </Grid>
  );
};

export default NumberWidgetsList;
